import { useDispatch } from "react-redux";
import { addNode } from "../utils/flowSlice";
import { useContext, useState } from "react";
import { LiaTimesSolid } from "react-icons/lia";
import axios from "./../utils/axiosInstance";
import { BiLoaderCircle } from "react-icons/bi";
import { DarkModeContext } from "../context/DarkModeContext";
import { FiFacebook } from "react-icons/fi";

const Facebook = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState(false);
  const [url, setUrl] = useState(null);
  const handleYoutubeButtonClicked = async () => {
    setModal(true);
  };

  const handleAddButton = async () => {
    try {
      setLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_BASED_URL}/service/facebook`,
        {
          url,
        }
      );

      // console.log("response: ", response.data);

      dispatch(
        addNode({
          type: "facebookNode",
          imageUrl: response.data.imageUrl,
          sourceUrl: url,
          script: response.data.script,
        })
      );

      setLoading(false);
      setModal(false);
      setUrl(null);
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  const handleCloseModal = () => {
    setModal(false); // Hide the modal
    setActiveTooltip(null);
  };
  const { darkMode } = useContext(DarkModeContext);

  // State to track hover for each icon
  const [activeTooltip, setActiveTooltip] = useState(null);

  const handleMouseEnter = (id) => {
    setActiveTooltip(id);
  };

  const handleMouseLeave = () => {
    setActiveTooltip(null);
  };

  return (
    <div
      className="rounded-lg flex justify-center items-center relative hover:cursor-pointer"
      onMouseEnter={() => handleMouseEnter("facebook")}
      onMouseLeave={handleMouseLeave}
    >
      <button
        className={`w-10 h-10 mt-0.5 mx-0.5 flex items-center justify-center rounded-full transition opacity-50 ${
          darkMode ? "text-neutral-600" : "text-white"
        }`}
        onClick={handleYoutubeButtonClicked}
      >
        <FiFacebook size={24} />
      </button>
      {activeTooltip === "facebook" && (
        <span className="absolute left-full ml-2 whitespace-nowrap bg-gray-700 text-white text-xs rounded py-1 px-2 z-10">
          Facebook Video
        </span>
      )}

      {modal && (
        <div
          className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center"
          onClick={handleCloseModal} // Close the modal when clicking the background
        >
          <div
            className="w-[500px] h-auto relative bg-white rounded-[8px] shadow-lg p-6 "
            onClick={(e) => e.stopPropagation()} // Prevent background click from closing the modal
          >
            <div className="flex justify-between">
              <p className="font-semibold text-lg">Enter Facebook URL</p>
              <span
                className="mt-[-5px] mr-[-10px] hover:cursor-pointer"
                onClick={handleCloseModal}
              >
                <LiaTimesSolid />
              </span>
            </div>

            <input
              type="text"
              className="w-[100%] bg-slate-800 rounded-[8px] shadow-lg text-lg p-2 mt-2 text-white font-semibold"
              value={url}
              onChange={(e) => setUrl(e.target.value)}
              placeholder="Enter URL"
            ></input>
            <button
              className="w-[100%] bg-purple-700 mt-3 text-white font-semibold p-2 rounded-[8px] hover:bg-purple-800 flex justify-center"
              onClick={handleAddButton}
              disabled={loading}
            >
              {loading ? (
                <BiLoaderCircle className="loading-icon" color="white" />
              ) : (
                "Add Video"
              )}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Facebook;
